import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginCallback.css';
import background from '../../assets/background.png';
import errorImage from '../../assets/close-browser-error.svg';
import { Container } from 'reactstrap';
import { Header } from '../../components/Header/Header';
import { SuccessMessage } from '../../components/SuccessMessage/SuccessMessage';
import { ErrorMessage } from '../../components/ErrorMessage/ErrorMessage';
import { authLogin } from '../../services/vidcredentials';
import axiosInstance from '../../services/axiosInstance';
import { AuthContext } from '../../contexts/AuthContext';
import { Spinner } from '../../components/Spinner/Spinner';
import { useTranslation } from 'react-i18next';
import { UserAuth } from '../../domain/userAuth';

export function LoginCallback() {
  const { t } = useTranslation();
  const { setToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hasBeenSuccess, setHasBeenSuccess] = useState(false);
  const [hasBeenError, setHasBeenError] = useState(false);

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (!code) {
      setHasBeenError(true);
      return;
    }
    console.log('Callback code: ', code);

    const login = async () => {
      try {
        const sessionToken = await authLogin(code);
        if ('error' in sessionToken) {
          setHasBeenError(true);
          setLoading(false);
          return;
        }
        setLoading(false);
        setHasBeenSuccess(true);
        const accessToken = sessionToken.access_token;

        axiosInstance.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${accessToken}`;
        setToken(accessToken);

        const user = new UserAuth(accessToken);

        if (user.isAdmin() || user.isOperator()) navigate('/credentials');
        if (user.isSuperadmin()) navigate('/user-credentials');
      } catch (error) {
        setLoading(false);
        console.log('Error unable to login');
        setHasBeenError(true);
        return;
      }
    };
    login();
  }, []);
  return (
    <>
      <Container>
        <Header />
        <section className="home-container">
          {loading ? (
            <Spinner />
          ) : (
            <>
              <div className="info-column">
                {hasBeenSuccess && (
                  <SuccessMessage
                    messageTitle={t('login.successful')}
                    message={t('login.redirected')}
                  />
                )}
                {hasBeenError && (
                  <ErrorMessage
                    messageTitle={t('login.failed')}
                    message={t('login.try_again')}
                  />
                )}
              </div>
              <div className="background-column">
                <img
                  className={hasBeenSuccess ? 'success-image' : 'error-image'}
                  src={hasBeenSuccess ? background : errorImage}
                  alt="Background"
                />
              </div>
            </>
          )}
        </section>
      </Container>
    </>
  );
}
